import { Footer } from './Footer'

import { BrowserRouter as Router } from 'react-router-dom'
import { motion } from 'framer-motion'
import ScrollToTop from './utility/ScrollToTop'
import { Navigation } from './Navigatgion'
import { AnimatedRoutes } from './router/AnimatedRoute'
import { useEffect, useState } from 'react'
import { Loading } from './utility/Loading'
import { AnimationOpacity } from './utility/AnimationOpacity'

function App() {
    const [showButton, setShowButton] = useState(false)
    const [imgsLoaded, setImgsLoaded] = useState(false)
    const IMAGES = [
        {
            url: `${process.env.PUBLIC_URL}/images/kv.webp`,
        },
        {
            url: `${process.env.PUBLIC_URL}/images/kv-tablet.webp`,
        },
        {
            url: `${process.env.PUBLIC_URL}/images/kv-mobile.webp`,
        },
        {
            url: `${process.env.PUBLIC_URL}/images/kv-mobile.webp`,
        },
        {
            url: `${process.env.PUBLIC_URL}/images/PB_TheLastHero_Logo_Small.webp`,
        },
    ]

    const loadResources = () => {
      const font1 = new FontFace('Baby Pop', `${process.env.PUBLIC_URL}/fonts/FOT-BabyPopStd-EB.otf`)
      const font2 = new FontFace('Humming', `${process.env.PUBLIC_URL}/fonts/FOT-HummingStd-B.otf`)
        const loadImage = (image) => {
            return new Promise((resolve, reject) => {
                const loadImg = new Image()
                loadImg.src = image.url
                loadImg.onload = () => resolve(image.url)
                loadImg.onerror = reject
            })
        }

        const imagePromises = IMAGES.map((image) => loadImage(image))
        const fontPromises = [font1.load(), font2.load()]

        return Promise.all([...imagePromises, ...fontPromises]).then(() => {
            document.fonts.add(font1)
            document.fonts.add(font2)
        })
    }

    useEffect(() => {
        const minLoadingTime = 3000
        const startTime = Date.now()

        const timer = setTimeout(() => {
            setImgsLoaded(true)
        }, minLoadingTime)

        loadResources()
            .then(() => {
                const elapsedTime = Date.now() - startTime
                const remainingTime = minLoadingTime - elapsedTime
                if (remainingTime > 0) {
                    setTimeout(() => setImgsLoaded(true), remainingTime)
                } else {
                    setImgsLoaded(true)
                }
            })
            .catch((err) => {
                clearTimeout(timer)
                setImgsLoaded(true)
            })

        return () => clearTimeout(timer)
    }, [])

    useEffect(() => {
        window.addEventListener('scroll', () => {
            if (window.pageYOffset > 300) {
                setShowButton(true)
            } else {
                setShowButton(false)
            }
        })
    }, [])

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }
    useEffect(() => {
        const onscroll = () => {
            const scrolledTo = window.scrollY + window.innerHeight
            const isNearBottom = document.body.scrollHeight - scrolledTo <= 300
            if (isNearBottom) setShowButton(false)
        }
        window.addEventListener('scroll', onscroll)
        return () => {
            window.removeEventListener('scroll', onscroll)
        }
    }, [])

    return (
        <Router basename={process.env.PUBLIC_URL}>
            {!imgsLoaded ? (
                <>
                    <div className='bg-island'>
                        <Loading />
                    </div>
                </>
            ) : (
                <>
                    <AnimationOpacity>
                        <ScrollToTop />
                        <div className='bg-island'>
                            <Navigation />
                            <div className='md:-mt-[80px]'>
                                <AnimatedRoutes />
                                <Footer />{' '}
                            </div>{' '}
                        </div>{' '}
                        {showButton && (
                            <motion.button
                                initial={{
                                    opacity: 0,
                                    transition: {
                                        duration: 1,
                                        ease: 'easeInOut',
                                    },
                                }}
                                whileInView={{
                                    opacity: 1,
                                    transition: {
                                        duration: 1,
                                        ease: 'easeInOut',
                                    },
                                }}
                                viewport={{ once: false }}
                                onClick={scrollToTop}
                                className='fixed bottom-0 right-1 md:right-[8px] cursor-pointer z-20 duration-300'
                            >
                                <img
                                    className='w-2/5 md:w-4/5 ml-auto'
                                    src={`${process.env.PUBLIC_URL}/images/top.png`}
                                    alt='scroll to top'
                                />{' '}
                            </motion.button>
                        )}{' '}
                        {showButton && (
                            <motion.button
                                initial={{
                                    opacity: 0,
                                    transition: {
                                        duration: 1,
                                        ease: 'easeInOut',
                                    },
                                }}
                                whileInView={{
                                    opacity: 1,
                                    transition: {
                                        duration: 1,
                                        ease: 'easeInOut',
                                    },
                                }}
                                viewport={{ once: false }}
                                onClick={scrollToTop}
                                className='hidden md:block fixed bottom-20 -left-1 md:-left-1 cursor-pointer z-20 duration-300'
                            >
                                <a
                                    target='_blank'
                                    rel='noreferrer'
                                    href='https://store.nisamerica.com/products/phantom-brave-the-lost-hero'
                                >
                                    <img
                                        className='w-2/5 md:w-3/5 mr-auto hover:brightness-110 duration-300'
                                        src={`${process.env.PUBLIC_URL}/images/buynow.webp`}
                                        alt='scroll to top'
                                    />{' '}
                                </a>
                            </motion.button>
                        )}{' '}
                    </AnimationOpacity>
                </>
            )}
        </Router>
    )
}

export default App
